module.exports = __webpack_public_path__ + "media/images/icons/mp_mobile-1960fac9549b89a454cd2379eb4e07d1.svg";